
export enum SignalRHubEnum {
    DataRefresh = 'datarefreshhub',
    LiveData = 'livedatanotificationhub',
    Export = 'exportnotificationhub',
    UserMessage = 'usermessagenotificationhub',
    DataFileImport = "datafileimportnotificationhub",
    RulesEngineSimulation = 'rulesenginesimulationhub',
    CreateObject = 'createobjectnotificationhub',
};

export interface ISignalRHubConfiguration {
    id: SignalRHubEnum;
    path: string;
    methodName: string,
};

const signalRHubConfiguration: ISignalRHubConfiguration[] = [{
    id: SignalRHubEnum.DataRefresh,
    path: 'datarefreshhub',
    methodName: 'onDataRefreshNotify'
},{
    id: SignalRHubEnum.Export,
    path: SignalRHubEnum.Export,
    methodName: 'onExportNotify'
},{
    id: SignalRHubEnum.UserMessage,
    path: SignalRHubEnum.UserMessage,
    methodName: 'onUserMessageNotify'
},{
    id: SignalRHubEnum.LiveData,
    path: 'livedatanotificationhub',
    methodName: 'onLiveDataNotify'
},{
    id: SignalRHubEnum.DataFileImport,
    path: SignalRHubEnum.DataFileImport,
    methodName: 'onDataFileImportNotify'
},{
    id: SignalRHubEnum.RulesEngineSimulation,
    path: SignalRHubEnum.RulesEngineSimulation,
    methodName: 'onRulesEngineSimulationNotify'
},{
    id: SignalRHubEnum.CreateObject,
    path: SignalRHubEnum.CreateObject,
    methodName: 'onCreateObjectNotify'
}];

export default signalRHubConfiguration;



